import { useState } from "react";
import styles from "../../SkillsExpertise.module.scss";

function CategoryCard({ cat, animate, delay }) {
    const [hovered, setHovered] = useState(null);

    return (
        <div
            className={styles["se-cat-card"]}
            style={{
                opacity: animate ? 1 : 0,
                transform: animate ? "translateY(0)" : "translateY(24px)",
                transition: `opacity 0.55s ease ${delay}s, transform 0.55s ease ${delay}s`,
            }}
        >
            <div className={styles["se-cat-top-bar"]} style={{ background: cat.color }} />

            <div className={styles["se-cat-head"]}>
                <div className={styles["se-cat-left"]}>
                    <div className={styles["se-cat-icon-wrap"]} style={{ background: cat.bg }}>
                        {cat.icon}
                    </div>
                    <div>
                        <div className={styles["se-cat-title"]}>{cat.label}</div>
                        <div className={styles["se-cat-sub"]}>{cat.sub}</div>
                    </div>
                </div>
                <div
                    className={styles["se-count-badge"]}
                    style={{ background: cat.bg, color: cat.color }}
                >
                    {cat.skills.length} skills
                </div>
            </div>

            <div className={styles["se-skills-grid"]}>
                {cat.skills.map((sk, i) => (
                    <div
                        key={sk.name}
                        style={{ position: "relative" }}
                        onMouseEnter={() => setHovered(i)}
                        onMouseLeave={() => setHovered(null)}
                    >
                        <div
                            className={styles["se-skill"]}
                            style={{
                                opacity: animate ? 1 : 0,
                                transition: `opacity 0.45s ease ${delay + 0.06 * i}s, transform 0.45s ease ${delay + 0.06 * i}s`,
                                borderColor: hovered === i ? "transparent" : "#eeeeeb",
                                background: hovered === i ? cat.bg : "#fafaf8",
                                boxShadow:
                                    hovered === i ? "0 8px 24px rgba(0,0,0,0.08)" : "none",
                                transform:
                                    hovered === i
                                        ? animate
                                            ? "translateY(-2px)"
                                            : "translateY(12px)"
                                        : animate
                                            ? "translateY(0)"
                                            : "translateY(12px)",
                            }}
                        >
                            <div className={styles["se-skill-row"]}>
                                <div className={styles["se-skill-left"]}>
                                    <span className={styles["se-skill-emoji"]}>{sk.icon}</span>
                                    <span className={styles["se-skill-name"]}>{sk.name}</span>
                                </div>
                                <span
                                    className={styles["se-skill-pct"]}
                                    style={{ color: hovered === i ? cat.color : "#bbb" }}
                                >
                                    {sk.level}%
                                </span>
                            </div>
                            <div className={styles["se-mini-track"]}>
                                <div
                                    className={styles["se-mini-fill"]}
                                    style={{
                                        width: animate ? `${sk.level}%` : "0%",
                                        background: `linear-gradient(90deg, ${cat.color}, ${cat.color}99)`,
                                        transitionDelay: animate ? `${delay + 0.06 * i}s` : "0s",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CategoryCard;
